/** The largest value the backend's int limit fields hold (BatchService.cs MaxRows, MaxBytes). */
const INT_MAX = 2147483647

/**
 * A Batch limit as typed. The backend field is an int, and a limit of zero or less means nothing, so only a
 * positive whole number that fits an int is a limit. Anything else, including an emptied input, is no limit (null).
 */
export function limitFromText(typed: string): number | null {
  const number = Number(typed)
  const isLimit = typed.trim() !== '' && Number.isInteger(number) && number > 0 && number <= INT_MAX
  return isLimit ? number : null
}
